import { faBus, faCar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FunctionComponent } from 'react';

type IconSwitchProps = {
  enabled: boolean;
  onChangeEnabledBuses: () => void;
};

const IconSwitch: FunctionComponent<IconSwitchProps> = ({
  enabled,
  onChangeEnabledBuses
}) => {
  return (
    <button
      onClick={onChangeEnabledBuses}
      className={`w-20 h-10 flex items-center rounded-full p-1 transition-colors duration-300 ${
        enabled ? 'bg-blue-200' : 'bg-gray-200'
      }`}
    >
      <div
        className={`w-8 h-8 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
          enabled ? 'translate-x-10' : 'translate-x-0'
        }`}
      >
        <span className="flex items-center justify-center h-full">
          <div className="w-fit">
            {enabled ? (
              <FontAwesomeIcon size="lg" icon={faBus} color="#d1d1d1" />
            ) : (
              <FontAwesomeIcon size="lg" icon={faCar} color="#d1d1d1" />
            )}
          </div>
        </span>
      </div>
    </button>
  );
};

export default IconSwitch;
